/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 手動調整発注数
 * @export
 * @interface ShipQuantityPlan
 */
export interface ShipQuantityPlan {
}

/**
 * Check if a given object implements the ShipQuantityPlan interface.
 */
export function instanceOfShipQuantityPlan(value: object): value is ShipQuantityPlan {
    return true;
}

export function ShipQuantityPlanFromJSON(json: any): ShipQuantityPlan {
    return ShipQuantityPlanFromJSONTyped(json, false);
}

export function ShipQuantityPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipQuantityPlan {
    return json;
}

export function ShipQuantityPlanToJSON(json: any): ShipQuantityPlan {
    return ShipQuantityPlanToJSONTyped(json, false);
}

export function ShipQuantityPlanToJSONTyped(value?: ShipQuantityPlan | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

